import { Project } from "../../../api/types";
import {
  ObjectValidatorsMap,
  ObjectMapValidator,
  rangeCharactersValidator,
} from '../../../components/Validator';

const FeatureCatalogValidatorMap: ObjectValidatorsMap<Project> = {
  name: rangeCharactersValidator(1, 101, 'Feature catalog name is required with a length between 2 and 100 characters.'),
  description: rangeCharactersValidator(-1, 250, 'The description has a maximum length of 250 characters.')
}

const FeatureCatalogValidator = new ObjectMapValidator<Project>(FeatureCatalogValidatorMap);

export default FeatureCatalogValidator;